import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCheckMarkOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M8.01 18.938 0 10.928 1.067 9.86l8.01 8.01L22.944 4.006 24 5.061 9.067 19.994z" /></svg>
);
